export const PERMISSION = {
  VIEW: 'CRM_LEADSTATUS_VIEW',
  ADD: 'CRM_LEADSTATUS_ADD',
  EDIT: 'CRM_LEADSTATUS_EDIT',
  DEL: 'CRM_LEADSTATUS_DEL',
  DETAIL: 'CRM_LEADSTATUS_VIEW',
};

export const LEAD_STATUS_RESULT_TYPES = {
  NORMAL: 0,
  WON: 1,
  LOST: 2,
};

export const leadStatusResultOptions = [
  { label: 'Bình thường', value: LEAD_STATUS_RESULT_TYPES.NORMAL },
  { label: 'Chốt thành công', value: LEAD_STATUS_RESULT_TYPES.WON },
  { label: 'Mất lead', value: LEAD_STATUS_RESULT_TYPES.LOST },
];

export const leadStatusFilterResultOptions = [
  { label: 'Tất cả', value: -1 },
  ...leadStatusResultOptions,
];

export const leadStatusDefaultValues = {
  status_data_leads_name: '',
  status_data_leads_key: '',
  business_id: null,
  description: '',
  order_index: null,
  result_type: LEAD_STATUS_RESULT_TYPES.NORMAL,
  is_active: 1,
};

export const mapResultTypeFromDetail = (detail = {}) => {
  if (Number(detail?.is_won) === 1) return LEAD_STATUS_RESULT_TYPES.WON;
  if (Number(detail?.is_lost) === 1) return LEAD_STATUS_RESULT_TYPES.LOST;
  return LEAD_STATUS_RESULT_TYPES.NORMAL;
};

export const mapPayloadFromResultType = (values = {}) => {
  const resultType = Number(values?.result_type);
  return {
    ...values,
    is_won: resultType === LEAD_STATUS_RESULT_TYPES.WON ? 1 : 0,
    is_lost: resultType === LEAD_STATUS_RESULT_TYPES.LOST ? 1 : 0,
  };
};

export const getLeadStatusResultLabel = (record = {}) => {
  if (Number(record?.is_won) === 1) return 'Chốt thành công';
  if (Number(record?.is_lost) === 1) return 'Mất lead';
  return 'Bình thường';
};
